export const BREADCRUMB_CLICK = 'web - click - breadcrumb';
export const COOKIE_BANNER_DISMISSED = 'Cookie Banner Dismissed';
export const LANDING_PAGE_VIEW = 'Landing Page Viewed';
export const PLAN_CANCEL = 'Plan Cancelled';

// Tax(App) Page:
export const APP_LP_DOWNLOAD_CTA = 'App LP: Click download CTA';
export const SMS_FAILED = 'SMS: Failed to send';
export const SMS_INVALID_PHONE_NUMBER = 'SMS: Invalid Phone Number';
export const SMS_SENT = 'SMS: Sent';
export const TAX_LP_DOWNLOAD_CTA = 'Tax LP: Click download CTA';

// COVID19 Page:
export const COVID19_FINANCE_EMAIL_SUBSCRIBED = 'COVID-19 Finance Guide: Email Subscribed';
export const COVID19_FINANCE_QUICK_LINK_CLICK = 'COVID-19 Finance Guide: Quick Link Click';
export const COVID19_FINANCE_STATE_SELECT = 'COVID-19 Finance Guide: State Selected';
export const COVID19_FINANCE_TAB_CLICK = 'COVID-19 Finance Guide: Tab Click';
export const COVID19_FIND_WORK_TAB_CLICK = 'COVID-19 Find Work: Tab Click';
export const COVID19_FIND_WORK_TYPE_SELECT = 'COVID-19 Find Work: Type Selected';
export const COVID19_HEALTH_TAB_CLICK = 'COVID-19 Health Guide: Tab Click';
export const COVID19_HEALTH_ZIP_CODE_SEARCH = 'COVID-19 Health Guide: Zip Code Search';
export const COVID19_HUB_CTA_CLICK = 'COVID-19 Hub: CTA - Click';
export const COVID19_HUB_EMAIL_SUBSCRIBED = 'COVID-19 Hub: Email Subscribed';
export const COVID19_HUB_TAB_CLICK = 'COVID-19 Hub: TAB - Click';
export const COVID19_TAX_EMAIL_SUBSCRIBED = 'COVID-19 Tax Guide: Email Subscribed';
export const COVID19_TAX_TAB_CLICK = 'COVID-19 Tax Guide: Tab Click';

// Pre-registration:
export const PRE_REG_START = 'PRE REG: Start';
export const PRE_REG_SUBMIT_FORM = 'PRE REG: Submit Form';
export const PRE_REG_TEXT_REMINDER_YES = 'PRE REG: Text Reminder Yes';
export const PRE_REG_TEXT_REMINDER_NO = 'PRE REG: Text Reminder No';
export const PRE_REG_PHONE_SUBMIT = 'PRE REG: Phone Number Submit';
export const PRE_REG_ACCOUNT_CREATE = 'PRE REG: Account Create';
export const PRE_REG_COMPLETE_CTA = 'PRE REG: Complete CTA Click';
export const PRE_REG_WELCOME_BACK_CTA = 'PRE REG: Welcome Back CTA Click';
export const PRE_REG_OEP_COUNTDOWN_CTA = 'PRE REG: OEP Countdown CTA Click';
export const PRE_REG_BACK = 'PRE REG: Back Click';

// Dashboard
export const DASHBOARD_ANCILLARY_PRODUCT_CLICK = 'Dashboard: Ancillary Products CTA';
export const DASHBOARD_BANNER_CLICK = 'Dashboard: Banner click';
export const DASHBOARD_CONTINUE_APPLICATION = 'Dashboard: Continue Application';
// Health Coverage:
export const HEALTH_ENTRY_ZIP_CODE_ENTER = 'Health Entry: Zip code enter';
